<template>
    <b-form-group v-if="hasFormGroup"
                  :label="computedLabel"
                  label-for="last-verification-date-month-select"
                  :label-cols-sm="labelColsSm"
                  :label-cols-md="labelColsMd"
                  :label-cols-lg="labelColsLg"
                  :label-cols-xl="labelColsXl"
                  :content-cols-="contentColsSm"
                  :content-cols-md="contentColsMd"
                  :content-cols-lg="contentColsLg"
                  :content-cols-xl="contentColsXl">

        <template #label>
            {{ computedLabel }}
            <i
                v-if="computedTooltip" class="fas fa-info-circle text-muted cursor-help ml-1"
                v-b-tooltip.hover
                :title="computedTooltip"
            ></i>
        </template>

        <multiselect
            id="last-verification-date-month-select"
            placeholder="-"
            :searchable="false"
            :show-no-results="true"
            :allowEmpty="allowEmpty"
            :disabled="disabled || loading"
            open-direction="bottom"
            :options="options"
            v-model="selectedOption"
            track-by="value"
            label="label"
        >
            <template v-if="showClearIcon" slot="clear">
                <div
                    class="multiselect__clear"
                    @mousedown.prevent.stop="clearValue"
                ></div>
            </template>

        </multiselect>
    </b-form-group>

    <multiselect
        v-else
        id="last-verification-date-month-select"
        placeholder="-"
        :searchable="false"
        :show-no-results="true"
        :allowEmpty="allowEmpty"
        :disabled="disabled || loading"
        open-direction="bottom"
        :options="options"
        v-model="selectedOption"
        track-by="value"
        label="label"
    >
        <template v-if="showClearIcon" slot="clear">
            <div
                class="multiselect__clear"
                @mousedown.prevent.stop="clearValue"
            ></div>
        </template>

    </multiselect>
</template>
<script>

import Multiselect from "vue-multiselect";
import {capitalize} from "lodash";
import {CustomSelectMixin} from "../js/mixins";

export default {
    name: "LastVerificationDateMonthsSelect",
    mixins: [CustomSelectMixin],
    components: {
        Multiselect,
    },
    props: {
        months: {
            type: Number,
            required: false,
            default: 3
        },
    },
    created() {
        this.generateOptions()

        this.loading = false;
    },
    methods: {
        generateOptions() {
            const now = new Date();
            const currentMonth = now.getMonth(); // 0-based index
            const currentYear = now.getFullYear();

            for (let i = 0; i < this.months; i++) {
                const date = new Date(currentYear, currentMonth + i);
                const monthNumber = date.getMonth() + 1; // 1-based
                const year = date.getFullYear();

                const monthName = this.$t('months.' + monthNumber);
                const label = capitalize(this.$t('by {month}', {month: `${monthName}`}) + ` ${year}`);

                this.options.push({
                    value: i,
                    label
                });
            }
        },
    },
};
</script>
